import React from 'react'
import Link from 'next/link'

function Breadcrumb({ item }) {
    return (

        <>
            <div className="hidden lg:block container mx-auto text-sm py-3 px-5 lg:px-0">
                <div className="flex space-x-2 items-center leading-none">
                    <Link href="/">
                        <a title="Home">
                            <i className="fas fa-home text-brand-tertiary"></i>
                        </a>
                    </Link>
                    <span className="text-gray-400">/</span>
                    <Link href="/categories">
                        <a title="Products" className="text-brand-primary underline hover:no-underline">Products</a>
                    </Link>
                    
                    <span className="text-gray-400">/</span>
                    <span className="text-gray-600">{item.name}</span>
                </div>
            </div>
        </>
    );
}

export default Breadcrumb;